<ng-container *ngIf="isLoading() ; else content">


    <div class="flex items-center justify-center min-h-[300px]">
        <p-progress-spinner ariaLabel="loading item" />
    </div>
</ng-container>

<ng-template #content>

    <div class="lg:pt-2 bg-gray-20 lg:border-b border-gray-300">
        <div class=" container mx-auto lg:mb-20 ">

            <div class="flex flex-col lg:flex-row mx-auto">
                <div class="w-full">
                    <p class="text-xl text-[var(--charcoal)] mt-4"> Update your account information below. All fields
                        are
                        required unless otherwise indicated.
                    </p>
                </div>
            </div>
            <div class="flex flex-col md:gap-4 mx-auto mt-6 ">
                <form [formGroup]="form" class="lg:mt-6" (ngSubmit)="onSubmit()">
                    <div class="flex flex-col space-y-4">
                        <div>
                            <label class="font-medium">First Name</label>
                            <input formControlName="firstName"
                                class="p-inputtext w-full border rounded-md px-3 py-2 text-sm disabled:bg-gray-100 disabled:text-gray-500 disabled:cursor-not-allowed" />
                            <small class="text-red-500 block min-h-[1rem]"
                                [ngClass]="{ 'invisible': !getFieldError('firstName')}">
                                {{ getFieldError('firstName') || '' }}
                            </small>
                        </div>
                        <div>
                            <label class="font-medium">Last Name</label>
                            <input formControlName="lastName"
                                class="p-inputtext w-full border rounded-md px-3 py-2 text-sm disabled:bg-gray-100 disabled:text-gray-500 disabled:cursor-not-allowed" />
                            <small class="text-red-500 block min-h-[1rem]"
                                [ngClass]="{ 'invisible': !getFieldError('lastName')}">
                                {{ getFieldError('lastName') || '' }}
                            </small>
                        </div>
                        <div>
                            <label class="font-medium">Email Address</label>
                            <input formControlName="email"
                                class="p-inputtext w-full border rounded-md px-3 py-2 text-sm disabled:bg-gray-100 disabled:text-gray-500 disabled:cursor-not-allowed" />
                            <small class="text-red-500 block min-h-[1rem]"
                                [ngClass]="{ 'invisible': !getFieldError('email')}">
                                {{ getFieldError('email') || '' }}
                            </small>
                        </div>
                    </div>
                    <div class="flex flex-col md:flex-row md:gap-8  mt-5 mb-12 ">
                        <div class="flex-1">
                            <label class="font-medium">Nickname (shown on bid history page)</label>
                            <input formControlName="nickname"
                                class="p-inputtext w-full border rounded-md px-3 py-2 text-sm" />
                            <small class="text-red-500 block min-h-[1rem]"
                                [ngClass]="{ 'invisible': !getFieldError('nickname')}">
                                {{ getFieldError('nickname') || '' }}
                            </small>
                        </div>
                        <div class="flex-1 mt-6 md:mt-0">
                            <label class="font-medium ">Mobile Phone Number</label>
                            <input formControlName="mobilePhone"
                                class="p-inputtext w-full border rounded-md px-3 py-2 text-sm" />
                        </div>
                    </div>
                    <div class="flex grid grid-cols-3 gap-x-[30px] gap-y-[15px] mt-[30px] flex-wrap-reverse">
                        <div class="lg:col-span-1 col-span-3 lg:order-0 order-1">
                            <button pButton type="button" [routerLink]="['/my-account']"
                                class="h-[35px] !font-noto-serif w-full"
                                [outlined]="true">
                                Back
                            </button>
                        </div>
                        <div class="lg:col-span-2 col-span-3 lg:order-1 order-0">
                            <button pButton 
                                class="h-[35px] !font-noto-serif w-full"
                                type="submit" [disabled]="form.invalid ">
                                Update
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</ng-template>